export default {
  computed: {
    column () {
      return this.page.columnProperties.find(x => x.id === this.page.columns[0])
    },
    values () {
      return (this.page) ? this.page.tree : []
    },
    hasGeneralText () {
      return this.page && this.page.page_texts[0]
    },
    test () {
      return 2
    }
  }
}
